import { render, staticRenderFns } from "./uploadfile.vue?vue&type=template&id=93b2cc0a"
import script from "./uploadfile.vue?vue&type=script&lang=tsx"
export * from "./uploadfile.vue?vue&type=script&lang=tsx"
import style0 from "./uploadfile.vue?vue&type=style&index=0&id=93b2cc0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports